/* eslint-disable react/no-unknown-property */
import {
  AvatarSkeleton, TextSkeleton, TypographyName,
} from '@doveit/bricks';
import React from 'react';
import * as styles from './AgentLeaderboardItem.style';
import useIsDevice from '../../../hooks/use-is-device/useIsDevice';
import { AgentLeaderboardItemProps } from './AgentLeaderboardItem';

export type AgentLeaderboardItemSkeletonProps = Pick<AgentLeaderboardItemProps, 'size'>;

export const AgentLeaderboardItemSkeleton: React.FC<AgentLeaderboardItemSkeletonProps> = ({
  size = 'M',
}) => {
  const isMobile = useIsDevice('mobile');

  return (
    <div
      css={styles.basic}
      $color="neutral"
    >
      <div
        css={styles.wrapper}
        $size={size}
        $isMobile={isMobile}
      >
        <div css={styles.primary}>
          <div css={styles.rankBox}>
            <div css={styles.rankLabel}>
              <TextSkeleton typography={TypographyName.MINI} width="3rem" />
            </div>
            <div
              css={styles.rankPosition}
              $color="neutral"
              $size={size}
              $isMobile={isMobile}
            >
              <TextSkeleton typography={size === 'S' || isMobile ? TypographyName.HEADING_4 : TypographyName.HEADING_2} />
            </div>
          </div>
          <div css={styles.userBox}>
            <AvatarSkeleton
              size={(isMobile || size === 'S') ? 'S' : 'M'}
            />
            <div>
              <TextSkeleton typography={TypographyName.BODY} width="8rem" />
              <TextSkeleton typography={TypographyName.BODY_SMALL} width="12rem" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentLeaderboardItemSkeleton;
